import axios from 'axios';
import { API_URL, API_VELTI_URL } from '../constants';

export const api = axios.create({
  baseURL: `${API_URL}/api/v1`,
});

export const api2 = axios.create({
  baseURL: `${API_VELTI_URL}/api/v1`,
});
